import moment from "moment";
import { CreditReportPersonalData } from "types/landlord/reports";
import { Row } from "views/applications-id-report/components/Row";
import { Section } from "views/applications-id-report/components/Section";
import { AlertCircle, EqualNot } from "untitledui-js-base";
import { SsnDisplay } from "shared/components/SsnDisplay";

interface PersonalDataProps {
  applicationId: string;
  applicantId: string;
  verificationId: string;
  personal_data?: CreditReportPersonalData;
  providedSSN?: string;
  ssnMismatched?: boolean;
  isNoHit: boolean;
}

export const PersonalData = ({
  applicationId,
  applicantId,
  verificationId,
  personal_data,
  providedSSN,
  ssnMismatched,
  isNoHit
}: PersonalDataProps) => {
  if (isNoHit)
    return (
      <Section sectionTitle="Response from Equifax" maxWidth="none">
        <p className="text-base font-medium text-content-300">
          No data available
        </p>
      </Section>
    );

  return (
    <Section sectionTitle="Credit bureau response" maxWidth="none">
      <div className="flex w-full flex-row flex-wrap">
        <div className="flex w-full flex-col gap-3">
          <Row title="Full name" value={personal_data?.full_name} />
          <Row
            title="SSN"
            value={
              <SsnDisplay
                displayValue={(data) => data.metadata?.personal_data?.ssn}
                applicationId={applicationId}
                applicantId={applicantId}
                verificationId={verificationId}
                maskedSsn={personal_data?.ssn || "--"}
              />
            }
          />
          <Row
            title="File pulled"
            value={
              personal_data?.file_pulled &&
              moment(personal_data.file_pulled).isValid() &&
              moment(personal_data.file_pulled).format("MMM DD, YYYY")
            }
          />
          <Row
            title="User ID/Member number"
            value={personal_data?.customer_number}
          />
          <Row
            title="Date of birth"
            value={
              personal_data?.dob &&
              moment(personal_data.dob).isValid() &&
              moment(personal_data.dob).format("MMM DD, YYYY")
            }
          />
        </div>
      </div>
    </Section>
  );
};
